import {
    RaikoBaseCardContainer,
    RaikoGridOneColumn,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined, showServerErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {useEffect, useState} from "react";
import {ProductVariantService} from "../../../serverService/productVariantService/ProductVariantService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";

export default function ProductVariantSku({variantId}) {

    const [productSku, setProductSku] = useState("");
    const [actionButtonLoading, setActionButtonLoading] = useState(false)
    const service = new ProductVariantService();
    const loading = new LoadingHelper(useLoadingDispatcher())

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getSkuFromServer()
        }
    }, [variantId]);


    function getSkuFromServer() {
        loading.show()
        service.getProductVariantSku(variantId)
            .then(response => {
                setProductSku(response.sku)
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleUpdateSku() {
        setActionButtonLoading(true)
        service.updateProductVariantSku(variantId, productSku)
            .then(response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setActionButtonLoading(false)
        })
    }

    return (
        <>
            <RaikoGridOneColumn>
                <RaikoBaseCardContainer>
                    <RaikoSectionContainer
                        title={"sku"}
                        hasActionButton
                        actionButtonOnclickWithValidation={handleUpdateSku}
                        actionButtonLoadingState={actionButtonLoading}

                    >
                        <RaikoSimpleInputOutlined
                            labelText={"sku"}
                            value={productSku}
                            setValue={setProductSku}
                            required
                        />

                    </RaikoSectionContainer>
                </RaikoBaseCardContainer>
            </RaikoGridOneColumn>
        </>
    )
}